import styles from "./Table-line.module.css"
import wifi from "../../../../assets/images/wifi.svg"
import noWifi from "../../../../assets/images/no_wifi.svg"
import cs from "clsx"
import { PlayersList } from "../../lib/players"
import Flag from "react-flagkit"
import moment from "moment"
interface Props {
  className: string
  player: PlayersList
}

export function TableLine({ className, player }: Props) {
  return (
    <div className={styles.root + " " + cs(styles.bg, className)}>
      <div className={styles.column + " " + styles.column_10}>
        {" "}
        <Flag className={styles.country} country={player?.countryCode.toUpperCase()} />
      </div>
      <div className={styles.column + " " + styles.column_70}>
        <div>
          <span className={styles.siteName}>{player?.subscriptionName}</span>
        </div>
        <div>
          <span className={styles.font}>
            {player?.productName} ({player?.displayName}){" "}
          </span>
        </div>
      </div>
      <div className={styles.column + " " + styles.column_20}>
        <div>
          {player?.online === true && <img src={wifi} className={styles.statusWifi} alt="wifi" />}
          {player?.online === false && <img src={noWifi} className={styles.statusWifi} alt="noWifi" />}
        </div>

        <div className={styles.statusGras}>{player?.lastConnection ? moment(player?.lastConnection).format("HH:mm:ss") : ""}</div>
        <div className={styles.status}>{player?.lastConnection ? moment(player?.lastConnection).format("DD/MM/yyyy") : ""}</div>
      </div>
    </div>
  )
}
